import React, {ReactDOM, useEffect, useRef, useState , useCallback,useContext} from "react";
import reactDom from "react-dom";
import axios from "axios";
import { Fragment } from "react";
import { LineChart, XAxis, YAxis, ZAxis, Tooltip, Line, CartesianGrid,ScatterChart, Legend, Scatter,  } from "recharts";
import { saveAs } from "file-saver";
import { useCurrentPng } from "recharts-to-png";
import { Link, useParams } from "react-router-dom";

import Contexto from '../comun/Contexto';
import '../../css/sismo_sentido.css';
import '../../css/resultados.css';
import MapaIntensidades from "./MapaIntensidades";
import LeyendaIntensidades from "./LeyendaIntensidades";
import Boton from "../comun/Boton";
import ResMapa from "./ResMapa";
import ResRespuestas from "./ResRespuestas";
import ResRtasTiempo from "./ResRtasTiempo";
import ResIntDist from "./ResIntDist";
import { PieDePagina } from "../comun/Pagina";

export default function Resultados({idSismo, irAPagina0}) {
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);    

    /* Estado */
    const [resumen, setResumen] = useState();
    const [conteo, setConteo] = useState({});
    const [respuestas, setRespuestas] = useState([]);
    const [modulo, setModulo] = useState("mapa");
    
    let params = useParams();
    if (typeof idSismo == undefined || idSismo == null) {
        idSismo=params.idSismo;
    }    
        
    /* Refs */
    const refOrdenamientos = useRef([1, 0,0,0,0,0,0]);       

    /* Efectos */
    useEffect(() => {       
        const traerDatos = async (url, callback) => {
            const res = await axios(url);           
            callback(res.data)
        }
    
        traerDatos(urlBaseRest+"resumen_sismo/"+ idSismo, setResumen);	        
        traerDatos(urlBaseRest+"conteo_respuestas/"+idSismo, setConteo);        
    }, []);

    useEffect(()=>{
        console.log("resumen")
        console.log(resumen)
    }, [resumen])

    /** Navegacion */
    const irAMapa = () => {
        setModulo("mapa");
    }

    const irATabla = () => {
        setModulo("tabla");
    }

    const irARtasTiempo = () => {
        setModulo("rtasTiempo");
    }

    const irAIntDist = () => {
        setModulo("intDist");
    }   

    /* Render */
    return (
        <div className="Formulario" >
            <div className="GraficosTitulo">Sismos sentidos</div>
            {resumen &&
            <div className="GraficosSubtitulo">
                {resumen.fecha}, {resumen.sitio}
            </div>
            }
            <div className="GraficosConteo">
                {conteo.conteo} formularios de {conteo.ncps} centros poblados            
            </div>
            
            <div className="Left100">                                
                
                {typeof irAPagina0 == "undefined" && <Link to="/">¿Sentiste este sismo? ¡Repórtalo aquí!</Link>}
                {typeof irAPagina0 != "undefined" && <a href="#" onClick={irAPagina0}>
                ¿Sentiste este sismo? ¡Repórtalo aquí!
                </a>}
            </div>     
            
            <div className="ResultadosBarraOpciones">
                <ResultadosBotonOpcion modulo={modulo} moduloDestino="mapa" texto="Mapa" onClick={irAMapa}/>&nbsp;
                <ResultadosBotonOpcion modulo={modulo} moduloDestino="tabla" texto="Respuestas" onClick={irATabla}/>&nbsp;
                <ResultadosBotonOpcion modulo={modulo} moduloDestino="rtasTiempo" texto="Respuestas vs Tiempo" onClick={irARtasTiempo}/>&nbsp;
                <ResultadosBotonOpcion modulo={modulo} moduloDestino="intDist" texto="Intensidad vs Distancia" onClick={irAIntDist}/>
            </div>
            <div style={{display: "flex", flex:1, flexDirection:"column", height:"100%", width:"100%", alignItems:"center"}}>
                { modulo === "mapa" && <ResMapa idSismo={idSismo} resumen={resumen} />}
                { modulo === "tabla" && <ResRespuestas idSismo={idSismo}/>}
                { modulo === "rtasTiempo"  && <ResRtasTiempo idSismo={idSismo}/>}
                { modulo === "intDist" && <ResIntDist idSismo={idSismo}/> }     
            </div>
            
            <PieDePagina/>       
        </div>
    );
}

export const traerRespuestas = async (urlBaseRest,idSismo, callback) => {
    const url = urlBaseRest+"tabla_respuestas/"+idSismo;
        console.log("url")
    console.log(url)

    const res = await axios(url);
    const nRes = res.data.map((r, index)=> {
        r.DIST = r.DIST.toFixed(2);
        r.LATITUD = r.LATITUD.toFixed(2);
        r.LONGITUD = r.LONGITUD.toFixed(2);
        return r;
    })
    callback(nRes)
}

const ResultadosBotonOpcion= (props)=> {
    const nada = ()=>{}
    return (
        <button                 
        className="ResultadosBotonOpcion"
        style={{backgroundColor: props.modulo == props.moduloDestino ? "red": "yellowgreen"}}
        type={props.tipo || "button"}
        onClick={props.onClick || nada}>
            {props.texto}
        </button>
    )
}